define('vspot-angular/resources/org-activity-resource',[], function () {
    'use strict';

    return ['$resource', function ($resource) {
        // AngularJS allows us to define multiple parameters in the same portion of the URL template.
        // As long as you only use one parameter at a time, AngularJS will construct the RESTful resource properly.
        // For params, if it is prefixed with @, then the value of that parameter is extracted from the data object
        // (useful for non-GET operations). In other words, if :controller is defined, :id should not, and vice versa.
        return $resource('/api/org_activities/:controller/:id',
            {
                id: '@id',
                controller: '@controller'
            },
            {
                /*
                 *  Gets a list of all activities.
                 *
                 *  @params sortType, showOption, currentPage, itemsPerPage, locallyUpdated
                 *
                 *  @returns  Resource object. See /resources.js documentation for details
                 *            Expected return data: { ??? }
                 */
                query: {
                    method:     'GET',
                    isArray:    false,
                    cache:      false
                },

                /*
                 * get:
                 *      Retrieve a single activity.
                 *      Locking is unrelated to get_activity_lock_info. This has to do with locking other organizers out.
                 *
                 * @param {int} id = id of the activity to retrieve
                 * @param {bool} lockActivity - request a lock on the activity at the same time we are requesting the activity data?
                 * @param {bool} override - *if* lockActivity set, do we want to override another user's lock if it exists?
                 * @param {bool} sendTotals - should the activity also calculate the progress.
                 * @returns Resource object
                 */
                get: {
                    method: 'GET',
                    cache: false
                },

                /*
                 *  Updates activity data. Make sure to include id in postData.
                 *
                 *  @param  postData  An object containing all the data to be updated
                 *
                 *  @returns  Resource object. See /resources.js documentation for details
                 */
                update: {
                    method: 'PUT'
                },

                /*
                 * Gets a full list of activities, not paginated.
                 *
                 * @param:  send_titles - {boolean} Set to true for just id and title,
                 *                       false for the full data set.
                 * @param:  include_past - {boolean} Set to true to include past activities.
                 * @param:  include_incomplete - {boolean} Set to true to include incomplete activities.
                 * @param:  images_only - {boolean} Set to true to only return activities that uploaded
                 *                        images (badges don't count).
                 *
                 * @returns  Resource object. See /resources.js documentation for details
                 */
                summary: {
                    method: 'GET',
                    cache: false,
                    params: {
                        controller: 'getmyactivitiessummary'
                    }
                },

                // Custom Questions section
                createExtraField: {
                    method: 'POST',
                    cache: false,
                    params: {
                        controller: 'create_extra_field'
                    }
                },

                updateExtraField: {
                    method: 'POST',
                    cache: false,
                    params: {
                        controller: 'update_extra_field'
                    }
                },


                deleteExtraField: {
                    method: 'POST',
                    cache: false,
                    params: {
                        controller: 'delete_extra_field'
                    }
                },


                /*
                 *  Unlock an activity for other organizers
                 *  (not related to get_activity_lock_info)
                 *
                 *  @param  { selected_activity: int }
                 *
                 *  @returns  Resource object. See /resources.js documentation for details
                 *            { status: boolean }
                 */
                unlockActivity: {
                    method: 'POST',
                    cache: false,
                    params: {
                        controller: 'unlockactivity'
                    }
                },

                /*
                 *  Returns whether or not a particular activity has spots (jobs or wampum amounts).
                 *
                 *  @param  { selected_activity: int }
                 *
                 *  @returns  Resource object. See /resources.js documentation for details
                 *            { status: boolean, hasSpots: boolean }
                 */
                hasSpots: {
                    method: 'POST',
                    cache: false,
                    params: {
                        controller: 'hasSpots'
                    }
                },

                /*
                 *  Returns status counts for the logged in user (number of activities of each type).
                 *
                 *  @returns  Resource object. See /resources.js documentation for details
                 *            {"status": boolean, "upcoming": int, "past": int, "ongoing": int, "all": int}
                 */
                getCounts: {
                    method: 'POST',
                    cache: false,
                    params: {
                        controller: 'getcounts'
                    }
                },

                /*
                 *  Adds a waiver to an activity. If a waiver exists, a new version will be recorded.
                 *
                 *  @returns  Resource object. See /resources.js documentation for details
                 */
                createWaiver: {
                    method: 'POST',
                    params: {
                        controller: 'create_waiver'
                    }
                },

                /*
                 *  Retrieves the latest waiver for the given activity.
                 *
                 *  @returns  Resource object. See /resources.js documentation for details
                 */
                getWaiver: {
                    method: 'GET',
                    params: {
                        controller: 'show_latest_waiver'
                    }
                },

                /*
                 *  Updates an activity's waiver. For now, only updates whether a waiver is
                 *  enabled or disabled (show/hide from participant's view).
                 *
                 *  @returns  Resource object. See /resources.js documentation for details
                 */
                updateWaiver: {
                    method: 'POST',
                    params: {
                        controller: 'update_waiver'
                    }
                },

                /*
                 *  Gets the list of groups that a given activity has
                 *  been published to.
                 *
                 *  @returns  Resource object. See /resources.js documentation for details
                 */
                getGroupsPublishedTo: {
                    method: 'POST',
                    params: {
                        controller: 'groups_i_published_to'
                    }
                },

                /*
                 * More than regular destroy. The destroy method basically moves
                 * a SignUp into an archived state. This function still doesn't
                 * delete the signup because Carol is paranoid. But it does keep
                 * the user from seeing the signup in their archived list.
                 */
                reallyDestroy: {
                    method: 'POST',
                    params: {
                        controller: 'really_destroy'
                    }
                },

                /*
                 * For an activity that have been "destroyed", but not "really 
                 * destroyed", we can use this function to restore it.
                 */
                restoreArchivedActivity: {
                    method: 'POST',
                    params: {
                        controller: 'restore_archived_activity'
                    }
                },

                /*
                 * Upload an image for the activity.
                 */
                uploadImage: {
                    method: 'POST',
                    params: {
                        controller: 'upload_image'
                    }
                },

                /*
                 * Remove the image for an activity.
                 */
                removeImage: {
                    method: 'POST',
                    params: {
                        controller: 'remove_image'
                    }
                },

                /*
                 * Copy the image from one activity to another.
                 */
                copyImage: {
                    method: 'POST',
                    params: {
                        controller: 'copy_image'
                    }
                },

                /*
                 * Get the large activity image.
                 */
                getLargeActivityImage: {
                    method: 'POST',
                    params: {
                        controller: 'get_large_activity_image'
                    }
                },

                /*
                 * Get the suggestions (drop-down items) for the extra fields.
                 */
                extraFieldsSuggestions: {
                    method: 'POST',
                    params: {
                        controller: 'extra_fields_suggestions'
                    }
                },

                newExtraFieldsSuggestions: {
                    method: 'POST',
                    params: {
                        controller: 'new_extra_fields_suggestions'
                    }
                },

                /*
                 * Get the Open/Close info.
                 * This relates to locking activities for Participants, not for other organizers.
                 *
                 * @param {int} selected_activity = id of the activity to retrieve
                 */
                getActivityLockInfo: {
                    method: 'GET',
                    params: {
                        controller: 'get_activity_lock_info'
                    }
                },

                /*
                 * Set the Open/Close info.
                 * This relates to locking activities for Participants, not for other organizers.
                 *
                 * @param {int} selected_activity = id of the activity to retrieve
                 * @param {bool} locked = true if activity is closed, false if activity is open
                 * @param {date} lock_date = date to lock the activity
                 * @param {date} unlock_date = date to unlock the activity
                 * @param {date} pre_lock_date = date to send the pre-lock message
                 * @param {str} pre_lock_message = pre-lock message content
                 * @param {date} pre_unlock_date = date to send the pre-unlock message
                 * @param {str} pre_unlock_message = pre-unlock message content
                 */
                setActivityLockInfo: {
                    method: 'POST',
                    params: {
                        controller: 'set_activity_lock_info'
                    }
                },
                /*
                 * Get the Open/Close info.
                 * This relates to locking events for Participants, not for other organizers.
                 *
                 * @param {int} selected_activity = id of the activity to retrieve
                 */
                getRollingActivityLockInfo: {
                    method: 'GET',
                    params: {
                        controller: 'get_rolling_activity_lock_info'
                    }
                },

                /*
                 * Set the Open/Close info.
                 * This relates to locking events for Participants, not for other organizers.
                 *
                 * @param {int} selected_activity = id of the activity to retrieve
                 * @param {bool} locked = true if activity is closed, false if activity is open
                 * @param {date} lock_date = date to lock the activity
                 * @param {date} unlock_date = date to unlock the activity
                 * @param {date} pre_lock_date = date to send the pre-lock message
                 * @param {str} pre_lock_message = pre-lock message content
                 * @param {date} pre_unlock_date = date to send the pre-unlock message
                 * @param {str} pre_unlock_message = pre-unlock message content
                 */
                setRollingActivityLockInfo: {
                    method: 'POST',
                    params: {
                        controller: 'set_rolling_activity_lock_info'
                    }
                }

            }
        );
    }];
});

